const STORAGE_KEY = 'recently_viewed_products';
const MAX_PRODUCTS = 10;

interface RecentlyViewedProduct {
  handle: string;
  timestamp: number;
  inventoryItem?: boolean;
}

export function addRecentlyViewedProduct(handle: string, inventoryItem?: boolean): void {
  const existingProducts = getRecentlyViewedProducts();

  // Remove if already exists (to move it to the front)
  const filteredProducts = existingProducts.filter((p) => p.handle !== handle);

  // Add to front with timestamp
  const newProduct: RecentlyViewedProduct = {
    handle,
    timestamp: Date.now(),
    inventoryItem,
  };

  filteredProducts.unshift(newProduct);

  // Keep only the most recent products
  const limitedProducts = filteredProducts.slice(0, MAX_PRODUCTS);

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(limitedProducts));
}

export function getRecentlyViewedProducts(): RecentlyViewedProduct[] {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  if (!stored) return [];

  try {
    return JSON.parse(stored);
  } catch {
    return [];
  }
}

export function getRecentlyViewedProductHandles(): string[] {
  return getRecentlyViewedProducts().map((p) => p.handle);
}

export function getRecentlyViewedProductsWithInventory(): RecentlyViewedProduct[] {
  return getRecentlyViewedProducts();
}

export function clearRecentlyViewedProducts(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
